import styled from 'styled-components';
import { breakpoints, css } from 'src/styles/theme';
import { WallboxSelectStyled } from '../WallboxSelectStyled';
import { rem } from 'polished';

export const WallboxSelectOV = styled(WallboxSelectStyled)`
    border-top: ${rem(1)} solid ${({ theme }) => theme.colors.grey16};

    .titleWrapper {
        .title {
            text-transform: capitalize;
            font-size: ${rem(22)};
        }
    }
`;
